import { ICheckoutModelLine } from "@the-volte/svc-core-sdk/lib/helpers";
import {
  ProductDetails_product_pricing,
  ProductDetails_product_variants_pricing,
} from "@the-volte/svc-core-sdk/lib/queries/gqlTypes/ProductDetails";
import * as React from "react";

import { ITaxedMoney } from "@types";

import { TaxedMoney } from "../../containers";
import * as S from "./styles";

const isEqual = (a: ITaxedMoney | null, b: ITaxedMoney | null) =>
  a &&
  b &&
  a.net.amount === b.net.amount &&
  a.net.currency === b.net.currency &&
  a.gross.amount === b.gross.amount &&
  a.gross.currency === b.gross.currency;
/**
 * Renders formatted price for chosen variant or product.
 * Price ranges and discounts are additionally formatted available.
 */
export const getProductPrice = (
  productPricingRange?: ProductDetails_product_pricing | null,
  variantPricing?: ProductDetails_product_variants_pricing | null
) => {
  if (variantPricing) {
    if (isEqual(variantPricing.priceUndiscounted, variantPricing.price)) {
      return (
        <TaxedMoney
          taxedMoney={{
            gross: {
              amount:
                variantPricing?.price?.gross?.amount +
                variantPricing?.borrowerFee?.gross?.amount,
              currency: variantPricing?.price?.gross?.currency,
            },
            net: {
              amount:
                variantPricing?.price?.net?.amount +
                variantPricing?.borrowerFee?.net?.amount,
              currency: variantPricing?.price?.net?.currency,
            },
          }}
        />
      );
    }
    return (
      <>
        <S.UndiscountedPrice>
          <TaxedMoney taxedMoney={variantPricing.priceUndiscounted} />
        </S.UndiscountedPrice>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <TaxedMoney taxedMoney={variantPricing.price} />
      </>
    );
  }

  if (!productPricingRange.priceRange) {
    return <></>;
  }

  const { start, stop } = productPricingRange.priceRange;
  if (isEqual(start, stop)) {
    return <TaxedMoney taxedMoney={start} />;
  }
  return (
    <>
      <TaxedMoney taxedMoney={start} /> - <TaxedMoney taxedMoney={stop} />
    </>
  );
};

export const getAfterpayPrice = (
  productPricingRange?: ProductDetails_product_pricing | null,
  variantPricing?: ProductDetails_product_variants_pricing | null
) => {
  if (variantPricing) {
    if (isEqual(variantPricing.priceUndiscounted, variantPricing.price)) {
      return (
        <TaxedMoney
          taxedMoney={{
            gross: {
              amount:
                (variantPricing?.price?.gross?.amount +
                  variantPricing?.borrowerFee?.gross?.amount) /
                4,
              currency: variantPricing?.price?.gross?.currency,
            },
            net: {
              amount:
                (variantPricing?.price?.net?.amount +
                  variantPricing?.borrowerFee?.net?.amount) /
                4,
              currency: variantPricing?.price?.net?.currency,
            },
          }}
        />
      );
    }
    return (
      <>
        <S.UndiscountedPrice>
          <TaxedMoney taxedMoney={variantPricing.priceUndiscounted} />
        </S.UndiscountedPrice>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <TaxedMoney taxedMoney={variantPricing.price} />
      </>
    );
  }

  if (!productPricingRange.priceRange) {
    return <></>;
  }

  const { start, stop } = productPricingRange.priceRange;
  if (isEqual(start, stop)) {
    return <TaxedMoney taxedMoney={start} />;
  }
  return (
    <>
      <TaxedMoney taxedMoney={start} /> - <TaxedMoney taxedMoney={stop} />
    </>
  );
};

export const canAddToCart = (
  items: ICheckoutModelLine[],
  isAvailableForPurchase: boolean,
  variantId: string,
  quantity: number
): boolean => {
  // Only allow one item in cart
  if (items?.length) return false;

  return isAvailableForPurchase && quantity > 0 && !!variantId;
};
